<template>
  <div>
    <page-title>Active Ports Report</page-title>
    <b-loading :is-full-page="true" :active.sync="$apollo.loading" :can-cancel="false"></b-loading>
    <data-table
      :data="activePorts"
      :isBordered="true"
      :isCheckable="false"
      :isPaginated="true"
      :perPage="perPage"
      :isPaginationSimple="isPaginationSimple"
      :backEndPagination="false"
      :defaultSortDirection="'ASC'"
      :defaultSort="'port_name'"
    >
      <template slot-scope="props">
        <b-table-column field="port_name" label="PORT NAME" sortable>
           <router-link
            :to="{
              name: 'port-report-details',
              params: { id: props.row.port_id, title: props.row.port_name }
            }"
            v-if="props.row.port_id"
          >
            {{ props.row.port_name }}
          </router-link></b-table-column>
        <b-table-column
          field="shipping_request_ids"
          label="NO BERTHED"
          numeric
          sortable
        >{{ props.row.shipping_request_ids.length }}</b-table-column>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>Nothing Active Ports Currently.</p>
            </div>
          </section>
        </template>
      </template>
    </data-table>
  </div>
</template>

<script>
import GetActivePorts from "@/modules/nimasaAgentModule/api/graphql/queries/GetActivePorts.gql";
import DataTable from "@/modules/commonModule/components/dataTable/Main";

export default {
  name: "ActivePortsReport",

  components: { DataTable },

  apollo: {
    activePorts: {
      query: GetActivePorts,
      update: data => data.GetActivePorts
    }
  },

  data() {
    return {
      activePorts: [],
      perPage: 20,
      isPaginationSimple: false
    };
  }
};
</script>
<style scoped="">
</style>


